import { ModuleContext } from '@/stores/moduleConst.js';
import commonFn from '@/commons/commonFunction.js';
import { useContextStore } from '@/stores/contextStore';
import EventEmitter from '@/lib/vue3-socket-io/emitter';
import moment from 'moment';

class AuthService extends EventEmitter {
  /**
   * Kiểm tra xem còn session đăng nhập ko
   * xử lý đăng xuất dvc khi hết session nhhoang1 27.02.2024
   */
  isAuthenticated() {
    const contextStore = useContextStore();
    const context = contextStore.context;
    if (context?.Token) {
      let expired = context.ExpiredToken;
      if (expired && moment(expired).toDate() > new Date()) {
        return true;
      }
    }
    return false;
  }

  /**
   * xử lý login qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để login
   */
  login(callbackUrl) {
    commonFn.mask();
    // build ra url gọi sang trang của misaid
    let state = new Date().getTime();
    if (callbackUrl) {
      state += '|' + callbackUrl;
    }
    const redirectUrl = window._misaId.getUrl('loginUrl').replace('{state}', state);
    location.href = redirectUrl;
  }
}

export default new AuthService();
